import knutselenVlinders from "@/assets/gallery/knutselen-vlinders.jpg";
import verhaalNoorderlicht from "@/assets/gallery/verhaal-noorderlicht.jpg";
import yogaSchildpad from "@/assets/gallery/yoga-schildpad.jpg";
import hakenMeisje from "@/assets/gallery/haken-meisje.jpg";
import yogaGroep from "@/assets/gallery/yoga-groep.jpg";
import knutselSter from "@/assets/gallery/knutsel-ster.jpg";
import kikkerYoga from "@/assets/gallery/kikker-yoga.jpg";
import kinderenLiggen from "@/assets/gallery/kinderen-liggen.jpg";
import scheerschuim from "@/assets/gallery/scheerschuim.jpg";
import snoezelen from "@/assets/gallery/snoezelen-jongens.jpg";
import knuffelMeisje from "@/assets/gallery/knuffel-meisje.jpg";
import knutselenPinguins from "@/assets/gallery/knutselen-pinguins.jpg";
import meditatieTweeling from "@/assets/gallery/meditatie-tweeling.jpg";
import spelKinderen from "@/assets/gallery/spel-kinderen.jpg";
import meisjeKatapult from "@/assets/gallery/meisje-katapult.jpg";
import rustKinderenMat from "@/assets/gallery/rust-kinderen-mat.jpg";
import verhaalVis from "@/assets/gallery/verhaal-vis.jpg";
import kinderenMatSpelen from "@/assets/gallery/kinderen-mat-spelen.jpg";
import yogaStretchen from "@/assets/gallery/yoga-stretchen.jpg";
import yogaBoom from "@/assets/gallery/yoga-boom.jpg";
import yogaKinderenMatSpelen2 from "@/assets/gallery/yoga-kinderen-mat-spelen2.jpg";
import yogaHeksenhoed from "@/assets/gallery/yoga-heksenhoed-meisje.jpg";
import yogaDierenLint from "@/assets/gallery/yoga-dieren-lint.jpg";
import yogaKinderenRusten from "@/assets/gallery/yoga-kinderen-rusten.jpg";
import yogaMeditatieTweeling2 from "@/assets/gallery/yoga-meditatie-tweeling2.jpg";
import yogaMeisjePompom from "@/assets/gallery/yoga-meisje-pompom.jpg";
import yogaMeisjeKatapult2 from "@/assets/gallery/yoga-meisje-katapult2.jpg";
import yogaHangmatKinderen from "@/assets/gallery/yoga-hangmat-kinderen.jpg";
import yogaMeisjeBeer from "@/assets/gallery/yoga-meisje-beer.jpg";
import yogaDriehoekDuo from "@/assets/gallery/yoga-driehoek-duo.jpg";
import yogaMeisjeArmen from "@/assets/gallery/yoga-meisje-armen.jpg";
import yogaMeisjeToverstaf from "@/assets/gallery/yoga-meisje-toverstaf.jpg";
import yogaKinderenKruipen from "@/assets/gallery/yoga-kinderen-kruipen.jpg";
import yogaScheerschuim2 from "@/assets/gallery/yoga-scheerschuim2.jpg";
import yogaSchildpadBoek from "@/assets/gallery/yoga-schildpad-boek.jpg";
import yogaSnoezelenLicht from "@/assets/gallery/yoga-snoezelen-licht.jpg";
import yogaKinderenSter from "@/assets/gallery/yoga-kinderen-ster.jpg";
import yogaJongensPlezier from "@/assets/gallery/yoga-jongens-plezier.jpg";

// Zomerkampjes foto's
import zomerSchilderenMeisje from "@/assets/gallery/zomer-schilderen-meisje.jpg?responsive";
import zomerKnuffelKinderen from "@/assets/gallery/zomer-knuffel-kinderen.jpg?responsive";
import zomerRollersSpel from "@/assets/gallery/zomer-rollers-spel.jpg?responsive";
import zomerKoeienVoeren from "@/assets/gallery/zomer-koeien-voeren.jpg?responsive";
import zomerHobermanMeisje from "@/assets/gallery/zomer-hoberman-meisje.jpg?responsive";
import zomerKnuffelBuiten from "@/assets/gallery/zomer-knuffel-buiten.jpg?responsive";
import zomerRustBeer from "@/assets/gallery/zomer-rust-beer.jpg?responsive";
import zomerHobermanDuo from "@/assets/gallery/zomer-hoberman-duo.jpg?responsive";
import zomerSchilderenJongen from "@/assets/gallery/zomer-schilderen-jongen.jpg?responsive";
import zomerSchilderenGroep from "@/assets/gallery/zomer-schilderen-groep.jpg?responsive";
import zomerIjsjesGroep from "@/assets/gallery/zomer-ijsjes-groep.jpg?responsive";
import zomerDuoKnuffel from "@/assets/gallery/zomer-duo-knuffel.jpg?responsive";
import zomerTentYogamatten from "@/assets/gallery/zomer-tent-yogamatten.jpg?responsive";
import zomerKinderenBoom from "@/assets/gallery/zomer-kinderen-boom.jpg?responsive";
import zomerIjsjesBuiten from "@/assets/gallery/zomer-ijsjes-buiten.jpg?responsive";
import zomerTekenenMeisjes from "@/assets/gallery/zomer-tekenen-meisjes.jpg?responsive";
import zomerMeisjeYogamatTent from "@/assets/gallery/zomer-meisje-yogamat-tent.jpg?responsive";
import zomerRustTentDuo from "@/assets/gallery/zomer-rust-tent-duo.jpg?responsive";
import zomerKnutselenStoffen from "@/assets/gallery/zomer-knutselen-stoffen.jpg?responsive";
import zomerMeisjeYogamatKnuffels from "@/assets/gallery/zomer-meisje-yogamat-knuffels.jpg?responsive";
import zomerTentHobermanDuo from "@/assets/gallery/zomer-tent-hoberman-duo.jpg?responsive";
import zomerIjsjesZon from "@/assets/gallery/zomer-ijsjes-zon.jpg?responsive";
import zomerPortretMeisjes from "@/assets/gallery/zomer-portret-meisjes.jpg?responsive";
import zomerTentFluitjes from "@/assets/gallery/zomer-tent-fluitjes.jpg?responsive";
import zomerMeisjeOntdekken from "@/assets/gallery/zomer-meisje-ontdekken.jpg?responsive";
import zomerMeisjeHobermanTent from "@/assets/gallery/zomer-meisje-hoberman-tent.jpg?responsive";
import zomerFeesttafelVerkleed from "@/assets/gallery/zomer-feesttafel-verkleed.jpg?responsive";
import zomerRustSpiderman from "@/assets/gallery/zomer-rust-spiderman.jpg?responsive";
import zomerVerkleedKnutselen from "@/assets/gallery/zomer-verkleed-knutselen.jpg?responsive";
import zomerSelfieHilde from "@/assets/gallery/zomer-selfie-hilde.jpg?responsive";
import zomerLintenBellenblaasTent from "@/assets/gallery/zomer-linten-bellenblaas-tent.jpg?responsive";
import zomerLintenBellenblaasWeide from "@/assets/gallery/zomer-linten-bellenblaas-weide.jpg?responsive";
import zomerLintenGroepTuin from "@/assets/gallery/zomer-linten-groep-tuin.jpg?responsive";
import zomerLintenDansZonnig from "@/assets/gallery/zomer-linten-dans-zonnig.jpg?responsive";
import zomerBellenblaasTipiWeide from "@/assets/gallery/zomer-bellenblaas-tipi-weide.jpg?responsive";
import zomerKnutseltentLampionnenMeisje from "@/assets/gallery/zomer-knutseltent-lampionnen-meisje.jpg?responsive";
import zomerZeepjesKnutselenTafel from "@/assets/gallery/zomer-zeepjes-knutselen-tafel.jpg?responsive";

import type { PictureSource } from "@/components/ResponsiveImage";

export type GalleryCategory = "yoga" | "zomerkampjes";

export interface GalleryImage {
  src: string | PictureSource;
  alt: string;
  category: GalleryCategory;
  span: "tall" | "wide" | "normal";
  featured?: boolean;
  chapter?: string;
}

/** Get a plain string URL from either a string src or a PictureSource. */
export const resolveSrc = (src: string | PictureSource): string =>
  typeof src === "string" ? src : src.img.src;

export const galleryImages: GalleryImage[] = [
  // ── YOGA ───────────────────────────────────────────────────
  {
    src: verhaalNoorderlicht,
    alt: "Winterse verhaaltafel met prentenboek Het licht dat door het donker danst",
    category: "yoga",
    span: "wide",
    featured: true,
    chapter: "Aankomst",
  },
  {
    src: kikkerYoga,
    alt: "Gehaakte kikker met yogakaarten en prentenboek Kikker is verliefd",
    category: "yoga",
    span: "tall",
    chapter: "Aankomst",
  },
  {
    src: verhaalVis,
    alt: "Verhaaltafel met prentenboek De mooiste vis van de zee en knuffels",
    category: "yoga",
    span: "normal",
    chapter: "Aankomst",
  },
  {
    src: yogaBoom,
    alt: "Twee meisjes doen de boomhouding in de yogaruimte",
    category: "yoga",
    span: "tall",
    featured: true,
    chapter: "Ontdekking",
  },
  {
    src: knuffelMeisje,
    alt: "Meisje ligt ontspannen op de yogamat met een grote ijsbeerknuffel",
    category: "yoga",
    span: "normal",
    chapter: "Ontdekking",
  },
  {
    src: yogaStretchen,
    alt: "Meisje strekt lachend uit tijdens een yogaoefening",
    category: "yoga",
    span: "normal",
    chapter: "Ontdekking",
  },
  {
    src: scheerschuim,
    alt: "Klein meisje speelt enthousiast met scheerschuim tijdens sensorisch spel",
    category: "yoga",
    span: "normal",
    chapter: "Ontdekking",
  },
  {
    src: knutselenVlinders,
    alt: "Twee meisjes tonen trots hun zelfgemaakte papieren vlinders",
    category: "yoga",
    span: "wide",
    featured: true,
    chapter: "Creatie",
  },
  {
    src: hakenMeisje,
    alt: "Meisje leert haken met blauwe wol tijdens een creatief moment",
    category: "yoga",
    span: "normal",
    chapter: "Creatie",
  },
  {
    src: meisjeKatapult,
    alt: "Meisje toont trots haar zelfgemaakte katapult",
    category: "yoga",
    span: "normal",
    chapter: "Creatie",
  },
  {
    src: knutselSter,
    alt: "Meisje toont haar zelfgemaakte ster van ijsstokjes en wol",
    category: "yoga",
    span: "normal",
    chapter: "Creatie",
  },
  {
    src: yogaGroep,
    alt: "Kinderen spelen samen een yogaspel op de mat",
    category: "yoga",
    span: "wide",
    featured: true,
    chapter: "Verbinding",
  },
  {
    src: snoezelen,
    alt: "Drie jongens lachen en spelen met lichtgevende vezels in de snoezelruimte",
    category: "yoga",
    span: "wide",
    featured: true,
    chapter: "Verbinding",
  },
  {
    src: knutselenPinguins,
    alt: "Kinderen knutselen samen pinguïns aan een ronde tafel",
    category: "yoga",
    span: "normal",
    chapter: "Verbinding",
  },
  {
    src: spelKinderen,
    alt: "Kinderen spelen samen op de blauwe mat tijdens een bewegingsspel",
    category: "yoga",
    span: "normal",
    chapter: "Verbinding",
  },
  {
    src: kinderenMatSpelen,
    alt: "Twee kinderen liggen speels op een golvende mat in de praktijk",
    category: "yoga",
    span: "normal",
    chapter: "Verbinding",
  },
  {
    src: meditatieTweeling,
    alt: "Twee meisjes mediteren in kleermakerszit met zachte verlichting",
    category: "yoga",
    span: "normal",
    chapter: "Stilte",
  },
  {
    src: yogaSchildpad,
    alt: "Kind rust uit in kindhouding met een grote schildpadknuffel op de rug",
    category: "yoga",
    span: "tall",
    featured: true,
    chapter: "Stilte",
  },
  {
    src: rustKinderenMat,
    alt: "Kinderen liggen samen te rusten op yogamatten met dekentjes",
    category: "yoga",
    span: "tall",
    featured: true,
    chapter: "Stilte",
  },
  {
    src: kinderenLiggen,
    alt: "Groep kinderen liggen ontspannen in een stervorm op de mat",
    category: "yoga",
    span: "wide",
    featured: true,
    chapter: "Stilte",
  },

  {
    src: yogaKinderenMatSpelen2,
    alt: "Drie kinderen spelen samen op de blauwe mat tijdens een yogales",
    category: "yoga",
    span: "normal",
    chapter: "Verbinding",
  },
  {
    src: yogaHeksenhoed,
    alt: "Meisje zit lachend met een heksenhoed op een roze yogamat",
    category: "yoga",
    span: "tall",
    chapter: "Ontdekking",
  },
  {
    src: yogaDierenLint,
    alt: "Kinderen spelen met gekleurde linten en dierenfiguren op yogamatten",
    category: "yoga",
    span: "wide",
    featured: true,
    chapter: "Ontdekking",
  },
  {
    src: yogaKinderenRusten,
    alt: "Groep kinderen ligt ontspannen samen op yogamatten met dekentjes",
    category: "yoga",
    span: "wide",
    featured: true,
    chapter: "Stilte",
  },
  {
    src: yogaMeditatieTweeling2,
    alt: "Twee meisjes mediteren in kleermakerszit met zachte sfeerverlichting",
    category: "yoga",
    span: "normal",
    chapter: "Stilte",
  },
  {
    src: yogaMeisjePompom,
    alt: "Meisje lacht uitgelaten terwijl ze een pompom vangt op de blauwe mat",
    category: "yoga",
    span: "tall",
    chapter: "Ontdekking",
  },
  {
    src: yogaMeisjeKatapult2,
    alt: "Meisje toont trots haar zelfgemaakte katapult tijdens de yogales",
    category: "yoga",
    span: "normal",
    chapter: "Creatie",
  },
  {
    src: yogaHangmatKinderen,
    alt: "Twee meisjes spelen samen met een grote stoffen hangmat",
    category: "yoga",
    span: "tall",
    chapter: "Verbinding",
  },
  {
    src: yogaMeisjeBeer,
    alt: "Meisje knuffelt een grote witte beer op de yogamat",
    category: "yoga",
    span: "wide",
    featured: true,
    chapter: "Stilte",
  },
  {
    src: yogaDriehoekDuo,
    alt: "Twee meisjes doen samen de driehoekshouding op gekleurde yogamatten",
    category: "yoga",
    span: "normal",
    chapter: "Verbinding",
  },

  {
    src: yogaMeisjeArmen,
    alt: "Meisje doet een yogahouding met gestrekte armen op een mat",
    category: "yoga",
    span: "tall",
    chapter: "Ontdekking",
  },
  {
    src: yogaMeisjeToverstaf,
    alt: "Klein meisje blaast naar een toverstaf tijdens een yogales",
    category: "yoga",
    span: "normal",
    chapter: "Ontdekking",
  },
  {
    src: yogaKinderenKruipen,
    alt: "Vier kinderen kruipen lachend over de blauwe mat",
    category: "yoga",
    span: "tall",
    chapter: "Verbinding",
  },
  {
    src: yogaScheerschuim2,
    alt: "Meisje toont trots haar handen vol scheerschuim tijdens sensorisch spel",
    category: "yoga",
    span: "normal",
    chapter: "Ontdekking",
  },
  {
    src: yogaSchildpadBoek,
    alt: "Schildpadknuffel met prentenboek Hoe Schildpad aan zijn Schild komt",
    category: "yoga",
    span: "normal",
    featured: true,
    chapter: "Aankomst",
  },
  {
    src: yogaSnoezelenLicht,
    alt: "Kinderen ontdekken lichtbollen in de snoezelruimte met sfeerlicht",
    category: "yoga",
    span: "tall",
    chapter: "Stilte",
  },
  {
    src: yogaKinderenSter,
    alt: "Groep kinderen liggen in een stervorm op de blauwe mat",
    category: "yoga",
    span: "wide",
    featured: true,
    chapter: "Stilte",
  },
  {
    src: yogaJongensPlezier,
    alt: "Vier jongens zitten lachend op elkaar in de yogaruimte",
    category: "yoga",
    span: "tall",
    chapter: "Verbinding",
  },

  // ── ZOMERKAMPJES ───────────────────────────────────────────
  {
    src: zomerKnuffelBuiten,
    alt: "Twee kinderen knuffelen lachend op het gras bij het zomerkamp",
    category: "zomerkampjes",
    span: "wide",
    featured: true,
  },
  {
    src: zomerSchilderenMeisje,
    alt: "Meisje schildert geconcentreerd met gele verf tijdens het zomerkamp",
    category: "zomerkampjes",
    span: "tall",
  },
  {
    src: zomerRollersSpel,
    alt: "Kinderen spelen samen met rollers en knuffels op yogamatten",
    category: "zomerkampjes",
    span: "wide",
    featured: true,
  },
  {
    src: zomerKoeienVoeren,
    alt: "Kinderen voeren kalfjes tijdens een uitstap op het zomerkamp",
    category: "zomerkampjes",
    span: "tall",
  },
  {
    src: zomerHobermanMeisje,
    alt: "Meisje speelt met een kleurrijke hoberman-bol in de tent",
    category: "zomerkampjes",
    span: "tall",
  },
  {
    src: zomerKnuffelKinderen,
    alt: "Drie kinderen knuffelen samen in de tent van het zomerkamp",
    category: "zomerkampjes",
    span: "normal",
  },
  {
    src: zomerRustBeer,
    alt: "Meisje rust uit op een roze yogamat met een grote teddybeer",
    category: "zomerkampjes",
    span: "wide",
    featured: true,
  },
  {
    src: zomerHobermanDuo,
    alt: "Twee meisjes spelen samen met een grote hoberman-bol in de tent",
    category: "zomerkampjes",
    span: "normal",
  },
  {
    src: zomerSchilderenJongen,
    alt: "Jongen schildert geconcentreerd een eierdoos groen tijdens het zomerkamp",
    category: "zomerkampjes",
    span: "normal",
  },
  {
    src: zomerSchilderenGroep,
    alt: "Drie meisjes schilderen samen eierdozen aan de knutseltafel",
    category: "zomerkampjes",
    span: "wide",
    featured: true,
  },
  {
    src: zomerIjsjesGroep,
    alt: "Groep kinderen geniet samen van kleurrijke ijsjes in de tuin tijdens het zomerkamp",
    category: "zomerkampjes",
    span: "wide",
    featured: true,
  },
  {
    src: zomerIjsjesBuiten,
    alt: "Kinderen zitten samen op een paletbank te smullen van ijsjes in de zon",
    category: "zomerkampjes",
    span: "wide",
    featured: true,
  },
  {
    src: zomerDuoKnuffel,
    alt: "Meisje en jongen poseren lachend met een knuffel in het gras",
    category: "zomerkampjes",
    span: "tall",
  },
  {
    src: zomerKinderenBoom,
    alt: "Kinderen ontdekken de natuur rond een grote boom tijdens het zomerkamp",
    category: "zomerkampjes",
    span: "normal",
  },
  {
    src: zomerTentYogamatten,
    alt: "Twee kinderen mediteren in de glamping tent met yogamatten en knuffels",
    category: "zomerkampjes",
    span: "wide",
    featured: true,
  },
  {
    src: zomerMeisjeYogamatTent,
    alt: "Lachend meisje zit op een paarse yogamat in de glamping tent",
    category: "zomerkampjes",
    span: "tall",
  },
  {
    src: zomerRustTentDuo,
    alt: "Twee meisjes rusten ontspannen op yogamatten in de tent tijdens een mindfulness moment",
    category: "zomerkampjes",
    span: "wide",
    featured: true,
  },
  {
    src: zomerMeisjeYogamatKnuffels,
    alt: "Meisje speelt met knuffels op een paarse yogamat in de glamping tent",
    category: "zomerkampjes",
    span: "normal",
  },
  {
    src: zomerTekenenMeisjes,
    alt: "Twee meisjes tekenen geconcentreerd aan de knutseltafel tijdens het zomerkamp",
    category: "zomerkampjes",
    span: "tall",
  },
  {
    src: zomerKnutselenStoffen,
    alt: "Meisjes versieren stoffen tasjes met fabric markers tijdens een creatieve workshop",
    category: "zomerkampjes",
    span: "normal",
  },
  {
    src: zomerIjsjesZon,
    alt: "Vrolijke groep kinderen geniet samen van ijsjes in de zon tijdens het zomerkamp",
    category: "zomerkampjes",
    span: "wide",
    featured: true,
  },
  {
    src: zomerFeesttafelVerkleed,
    alt: "Verkleede kinderen vieren feest aan de versierde tafel met lampionnen tijdens het zomerkamp",
    category: "zomerkampjes",
    span: "wide",
    featured: true,
  },
  {
    src: zomerTentHobermanDuo,
    alt: "Twee meisjes spelen samen met kleurrijke hoberman-bollen in de glamping tent",
    category: "zomerkampjes",
    span: "tall",
  },
  {
    src: zomerTentFluitjes,
    alt: "Lachende kinderen blazen op fluitjes tijdens een speels moment in de tent",
    category: "zomerkampjes",
    span: "wide",
    featured: true,
  },
  {
    src: zomerMeisjeHobermanTent,
    alt: "Meisje toont geconcentreerd een grote hoberman-bol op een roze yogamat in de tent",
    category: "zomerkampjes",
    span: "tall",
  },
  {
    src: zomerRustSpiderman,
    alt: "Drie kinderen rusten samen verkleed op yogamatten omringd door knuffels",
    category: "zomerkampjes",
    span: "normal",
  },
  {
    src: zomerVerkleedKnutselen,
    alt: "Verkleede kinderen knutselen samen met figuurtjes aan de creatieve tafel",
    category: "zomerkampjes",
    span: "normal",
  },
  {
    src: zomerMeisjeOntdekken,
    alt: "Klein meisje toont trots haar vondst tijdens een natuurontdekking op het zomerkamp",
    category: "zomerkampjes",
    span: "tall",
  },
  {
    src: zomerPortretMeisjes,
    alt: "Twee meisjes poseren dicht bij elkaar tijdens een knutselmoment buiten",
    category: "zomerkampjes",
    span: "normal",
  },
  {
    src: zomerSelfieHilde,
    alt: "Hilde maakt een vrolijke selfie met een lachend meisje in de glamping tent",
    category: "zomerkampjes",
    span: "normal",
  },
  {
    src: zomerLintenBellenblaasTent,
    alt: "Kinderen dansen met kleurrijke linten en bellenblaas voor de versierde tent met wilgenslingers",
    category: "zomerkampjes",
    span: "wide",
    featured: true,
  },
  {
    src: zomerLintenBellenblaasWeide,
    alt: "Kinderen spelen met regenbooglinten tussen bellenblaas op de weide bij de tipi",
    category: "zomerkampjes",
    span: "tall",
  },
  {
    src: zomerLintenGroepTuin,
    alt: "Groep kinderen danst samen met regenbooglinten in de zonnige tuin",
    category: "zomerkampjes",
    span: "wide",
    featured: true,
  },
  {
    src: zomerLintenDansZonnig,
    alt: "Kinderen zwaaien vrolijk met kleurrijke linten in de buitenlucht tijdens het zomerkamp",
    category: "zomerkampjes",
    span: "tall",
  },
  {
    src: zomerBellenblaasTipiWeide,
    alt: "Kinderen genieten van bellenblaas op de weide bij de witte tipi onder een blauwe lucht",
    category: "zomerkampjes",
    span: "wide",
    featured: true,
  },
  {
    src: zomerKnutseltentLampionnenMeisje,
    alt: "Lachend meisje aan de knutseltafel onder kleurrijke lampionnen in de tent",
    category: "zomerkampjes",
    span: "tall",
  },
  {
    src: zomerZeepjesKnutselenTafel,
    alt: "Kinderen knutselen samen zeepjes en figuurtjes onder de rode lampion tijdens het zomerkamp",
    category: "zomerkampjes",
    span: "normal",
  },
];

export const categoryLabels: Record<GalleryCategory, string> = {
  yoga: "Yoga",
  zomerkampjes: "Zomerkampjes",
};
